<template>
  <!-- 弹框组件 -->
  <el-dialog custom-class="sku-pop" :title="dialogTitle" :visible="dialogVisible" :width="dialogWidth" :before-close="hideDialog" :modal-append-to-body="false">
        <el-form :model="ruleForm" :rules="rules" ref="skuForm">
            <el-form-item label="分类方式:" prop="sku_attr">
                <el-select v-model="ruleForm.sku_attr">
                     <el-option label="规格" value="规格"></el-option>
                     <el-option label="颜色" value="颜色"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商品属性:" prop="sku_val">
              <el-input v-model="ruleForm.sku_val" placeholder="请输入商品属性"></el-input>
            </el-form-item>
            <el-form-item label="销售价格:" prop="price">
                <el-input v-model="ruleForm.price" placeholder="请输入商品价格"  oninput = "value=value.replace(/[^\d.]/g,'')" class="price-input" v-on:blur='dealmoney' ref='money'>
                  <template slot="prepend">￥</template>
                </el-input>
            </el-form-item>
            <el-form-item label="数量设置:" prop="product_number">
                <el-row class="counter-num">
                    库存数量
                    <el-input-number class="num-counter" v-model="ruleForm.product_number" @change="handleChange" :min="0" :max="10000" label="描述文字"></el-input-number>
                </el-row>
            </el-form-item>
            <el-form-item class="gallery" label="商品图库:" prop="thumb" >
               	<div v-if="ruleForm.thumb" style="display:inline-block">
                    <img :src="$url(ruleForm.thumb)" alt="">
                </div>
                <div  v-else style="display:inline-block">
                    <img :src="defaultImg" alt="">
                </div>
                <el-upload :show-file-list="false" action="/" accept="image/jpeg,image/png" class="upload-button" :on-change="handleSkuUpload" :before-upload="beforeSkuUpload">
                    <el-button type="primary">上传</el-button>
                </el-upload>
                <div class="form-item-des">（尺寸宽高比为1:1）</div>
            </el-form-item>
             <el-form-item class="popSku-submit">
                <el-button @click="submitSku">确 定</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>
<script>
export default {
  props: ["dialogVisible",'title'],
  data() {
    return {
        dialogWidth: '502px',
        dialogTitle: this.title,
        formLabelWidth: '120px',
        ruleForm: {
            sku_attr: '规格',
            sku_val: '',
            price: 0,
            product_number:1,
            thumb:'',
            _remove_: 0
        },
        defaultForm:  {
            sku_attr: '规格',
            sku_val: '',
            price: 0,
            product_number:1,
            thumb:'',
            _remove_: 0
        },
        defaultImg:"./static/img/defaultimg.png",
        rules: {
            sku_attr: [
                { required: true, message: '请选择分类方式', trigger: 'change' },
            ],
            sku_val: [
                { required: true, message: '商品属性不能为空', trigger: 'blur' }
            ],
            price: [
                { required: true, message: '销售价格不能为空', trigger: 'blur' },
            ],
            product_number: [
                { required: true, message: '库存数量不能为空', trigger: 'blur' },
                { type:'number',message:'库存数量必须为数字', trigger:'blur'}
            ],
            thumb: [
                { required: true, message: '商品图不能为空', trigger: 'change' },
            ],
        }
    };
  },
  created() {
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    //关闭弹窗
    hideDialog() {
      this.$emit("hideDg");
    },
    handleChange() {},
    //显示缩略图
    handleSkuUpload(file, fileList) {
            this.ruleForm.thumb = URL.createObjectURL(file.raw);
    },
    beforeSkuUpload(file) {
        this.ruleForm.skuThumb = file;//储存缩略图
        return false;
    },
    submitSku(){
        this.$refs["skuForm"].validate(valid => {
            if (valid) {
                this.$emit('commitSku',this.ruleForm);
                this.ruleForm = deepCopy(this.defaultForm);
                this.hideDialog();
            } else {
                return false;
            }
      });
    },
    dealmoney(){
        this.ruleForm.price = new Number(this.ruleForm.price).toFixed(2);
    },

  },

};
//对象深拷贝，防止传给子组件数据改变直接影响父组件
	var deepCopy = function (source) {
    var result = {};
    for(var key in source) {
        if(typeof source[key] === 'object') {
            result[key] = deepCopy(source[key])
        } else {
            result[key] = source[key]
        }
    }
    return result;
	}
</script>
<style lang="less">
    .sku-pop{
        width: 502px;
        padding: 15px 20px;
        background-color: #ffffff;

        .el-dialog__header {
            padding: 0;
            padding-bottom: 15px;
            text-align: left;
        }
        .el-dialog__title {
            height: 15px;
            font-size: 16px;
            text-align: left;
            line-height: 15px;
            color: #081234;
            font-weight: bold;
            padding-left: 6px;
            margin-bottom: 18px;
            border-left: 5px solid #2e71fe;
        }
        .el-dialog__body {
            padding: 0;
            .el-scrollbar__wrap {
            overflow-x: hidden;
            }
            .el-scrollbar__thumb {
            background-color: #c5c5c5;
            }
        }
        .el-form {
            padding: 20px 30px;
            border-top: 1px solid #f6f8fb;

             .el-form-item.gallery {
                .el-form-item__label{
                    line-height: 14px;
                }
                .el-form-item__content{
                    .upload-button {
                        display: inline-block;
                        // vertical-align: bottom;
				    }
                }
                img {
          width: 120px;
          height: 120px;
				}
              }
              .item-con-banner {
					.item-banner {
						position: relative;
						display: inline-block;
						vertical-align: bottom;
						width: 120px;
						margin-right: 20px;
						img {
							width: 120px;
							max-width: 120px;
							height: 120px;
						}
						i {
							position: absolute;
							display: block;
							padding: 5px;
							top: 0;
							right: 0;
							color: #ffffff;
							background-color: rgba(0, 0, 0, 0.3);
						}
					}
				}
              .el-button--primary {
                width: 56px;
                height: 29px;
                font-size: 12px;
                background-color: #2e71fe;
                border-radius: 19px;
                border: none;
            }
            .el-button--primary:focus,
            .el-button--primary:hover {
                color: #fff;
            }
            .el-form-item {
            margin-bottom: 20px;
            .el-form-item__label {
                width: 100px;
                text-align: left;
                font-weight: bold;
                color: #081234;
            }
            .el-form-item__content {
                color: #8d8f96;
                text-align: left;
            }
            .counter-num{
                padding:0 0 0 5px;
                color: #081234;
            }
            .el-input-number{
                position: relative;
                vertical-align: middle;
                width: 100px;
                height: 28px;
                padding: 4px;
                box-sizing: border-box;
                background-color: #f6f8fb;
                .el-input-number__decrease, .el-input-number__increase {
                    top: 4px;
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    background-color: #2E71FE;
                    color: #FFFFFF;
                }
                .el-input-number__decrease {
                    left: 4px;
                }
                .el-input-number__increase {
                    right: 4px;
                }
                .el-input {
                    width: 92px;
                    height: 20px;
                }
                .el-input__inner {
                    height: 20px !important;
                    padding: 0 !important;
                    vertical-align: top;
                }
            }
            .form-item-des {
                font-size: 12px;
                color: #ff6529;
                padding-left:100px;
            }
            .el-input {
                width: 300px;
                height: 45px;
                .el-input__inner {
                // width: 300px;
                height: 45px;
                line-height: 45px;
                background-color: #f6f8fb;
                border-radius: 0;
                border: none;
                }
            }
            .price-input{
                .el-input__inner {
                    width: 265.56px;
                    padding: 0;
                }
                .el-input-group__prepend{
                    border: none;
                    width: 5px;
                    padding: 10px;
                }
            }
            .top-line {
                margin-top: 15px;
                padding-top: 8px;
                border-top: 1px solid #f6f8fb;
            }
            &.popSku-submit {
                .el-form-item__content {
                text-align: right;
                }
                .el-button {
                width: 88px;
                height: 37px;
                padding: 0;
                margin-right: 0;
                text-align: center;
                background: #f6f8fb;
                border-radius: 19px;
                color: #8d8f96;
                border: none;
                }
                .el-button:hover {
                background: #2E71FE;
                color: #ffffff;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/popover/popAddSku.vue